import {compressAccurately} from "image-conversion";
import heic2any from 'heic2any'

export function resizeImage(file) {
  return compressAccurately(file, {
    size: 2048,
    accuracy: 0.9,
    type: "image/jpeg",
  })
      .then(blob => new File([blob], file.name, {type: "image/jpeg"}));
}

export function convertToHeic(file) {
  return heic2any({blob: file})
      .then(result => {
        return resizeImage(result)
      })
      .catch(err => {
        return resizeImage(file)
      })
}

export function isNumericLike(v) {
  if (typeof v === "number") return Number.isFinite(v);

  if (typeof v === "string") {
    const s = v.trim();
    if (s === "") return false; // reject empty / whitespace

    // Accept decimal/scientific numeric strings only (rejects "0x11", "12abc", etc.)
    const numericPattern = /^[+-]?(?:\d+\.?\d*|\.\d+)(?:e[+-]?\d+)?$/i;
    if (!numericPattern.test(s)) return false;

    return Number.isFinite(Number(s));
  }

  return false;
}

export function canMultiply(a, b) {
  return isNumericLike(a) && isNumericLike(b);
}

export function canDivide(a, b) {
  if (!isNumericLike(a) || !isNumericLike(b)) return false;

  const denom = Number(b);
  return denom !== 0; // blocks 0, "0", "0.0", "-0", etc.
}
